export default {
  CONTENT: {
    WIDTH: 900,
  },
};
